
/* ==========================================================================
    Force scroll to top on refresh
========================================================================== */

history.scrollRestoration = 'manual';

if (window.scrollY > 0) {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}


/* ==========================================================================
    check if operating system is macos
========================================================================== */

if (navigator.platform.toUpperCase().indexOf('MAC') >= 0) {
  document.body.classList.add('is-mac');
}



if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
  document.body.classList.add('is-ios');
}

// Alternative: More comprehensive iOS detection (includes newer iPads)
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
              (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

if (isIOS) {
  document.body.classList.add('is-ios');
}


function detectDevice() {
  const userAgent = navigator.userAgent;
  const platform = navigator.platform;
  
  // Detect Mac (desktop)
  if (platform.toUpperCase().indexOf('MAC') >= 0) {
    document.body.classList.add('is-mac');
  }
  
  // Detect iOS (iPhone, iPad, iPod)
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) || 
                (platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  
  if (isIOS && !window.MSStream) {
    document.body.classList.add('is-ios');
  }
}

// Run on page load
detectDevice();


document.addEventListener('DOMContentLoaded', () => {
  const parents = document.querySelectorAll('.fbw-paragraphs');
  if (!parents || !parents.length) return;
 
  parents.forEach(parent => {
    if (!parent.children || !parent.children.length) return;
     const isProductDetail = parent.classList.contains('fbw-product-detail-paragraphs');

    Array.from(parent.children).forEach((child, idx) => {
      if (!child) return;
      child.classList.add('wow', 'fbw-fadeInUp');
      if (isProductDetail) {
        // Staggered delay for product detail paragraphs
        const delay = 0.3 + (idx * 0.1);
        child.setAttribute('data-wow-delay', delay + 's');
      } else {
        // Simple 0.3s delay for all others
        child.setAttribute('data-wow-delay', '.3s');
      }
    });
    parent.classList.add('is-visible');
  });
});



 
new WOW().init();




/* ==========================================================================
   SWIPER

   • Initializes Swiper slider
   • Handles navigation, pagination, and breakpoints
========================================================================== */

 // Hero Swiper
  const heroEl = document.querySelector(".hero-Swiper");

  if (heroEl) {
    const speed = parseInt(heroEl.dataset.speed) || 3000;
    const delay = parseInt(heroEl.dataset.delay) || 2500;

    const heroSwiper = new Swiper(heroEl, {
      a11y: true,
      keyboard: { enabled: true },
      slidesPerView: 1,
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      speed: speed,
      autoplay: {
        delay: delay,
        disableOnInteraction: false,
      },
    });
  }

const soldoutSwiper = new Swiper(".soldout-products-swiper", {
  a11y: true,
  keyboard: { enabled: true },
  slidesPerView: 1,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },

  breakpoints: {
    390: {
      slidesPerView: 2,
      spaceBetween: 10,
    },

    640: {
      slidesPerView: 2,
      spaceBetween: 20,
      pagination: false,
    },

    950: {
      slidesPerView: 3,
      spaceBetween: 25,
      pagination: false,
    },
  },
});

const relatedProductSwiper = new Swiper(".related-products-swiper", {
  a11y: true,
  keyboard: { enabled: true },
  slidesPerView: 1,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },

  breakpoints: {
    500: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
  },
});

const relatedCocktailSwiper = new Swiper(".related-cocktail-swiper", {
  a11y: true,
  keyboard: { enabled: true },
  slidesPerView: 1,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },

  breakpoints: {
    500: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
  },
});

const featuredImageSwiper = new Swiper(".featured-image-swiper", {
  a11y: true,
  keyboard: { enabled: true },
  slidesPerView: 1.6, // Show 1 full image + 20% of next image on mobile
  spaceBetween: 16,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 2, // Show 2 full images on desktop
      spaceBetween: 30,
    },
  },
});



const relatedNewsSwiper = new Swiper(".related-news-swiper", {
  a11y: true,
  keyboard: { enabled: true },
  slidesPerView: 1,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },

  breakpoints: {
    500: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
  },
});



const featuredPostSwiper = new Swiper(".featured-post-swiper", {
  a11y: true,
  keyboard: { enabled: true },
  slidesPerView: 1,
  loop: true,
  spaceBetween: 10,
  //   autoplay: {
  //     delay: 2500,
  //     disableOnInteraction: false,
  //   },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },

  // breakpoints: {
  //   768: {
  //     pagination: false,
  //   },
  // },
});

const awardLogosSlider = new Swiper(".award-logos-slider", {
  a11y: true,
  keyboard: { enabled: true },
  slidesPerView: 3,
  // loop: true,
  spaceBetween: 12,
  // centeredSlides: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

   breakpoints: {
    900: {
      spaceBetween: 20,
    },
  },
});

const instaPostSwiper = new Swiper(".instgram_post-swiper", {
  slidesPerView: "auto",
  spaceBetween: 6,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  // loop: true,
});


const thumbnailSwiper = new Swiper(".thumbnail-swiper", {
  slidesPerView: "auto",
  spaceBetween: 5,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
   breakpoints: {
    780: {
      spaceBetween: 8,
    },
    1024: {
      spaceBetween: 10,
    },
  },
});

/* ==========================================================================
   Accessible marquee / top ticker

    * - Respects prefers-reduced-motion
    * - Creates seamless looping content
    * - Recalculates item count on resize
    * - Prevents screen readers from reading clones
========================================================================== */

const reducesMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)"
).matches;

if (!reducesMotion) initMarquee();

function initMarquee() {
  const marqueeScrollers = document.querySelectorAll(".marquee-scroller");

  marqueeScrollers.forEach((scroller) => {
    const inner = scroller.querySelector(".marquee-scroller__inner");
    if (!inner) return;

    setupScroller(scroller, inner);

    // Recalculate on resize (debounced)
    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        setupScroller(scroller, inner);
      }, 150);
    });
  });
}

function setupScroller(scroller, inner) {
  // Remove previously cloned items
  const originalItems = Array.from(inner.children).filter(
    (el) => !el.hasAttribute("aria-hidden")
  );

  // Reset inner to only original items
  inner.innerHTML = "";
  originalItems.forEach((el) => inner.appendChild(el));

  const containerWidth = scroller.getBoundingClientRect().width;
  const baseWidth = inner.scrollWidth;
  const originalCount = originalItems.length;

  if (!originalCount || baseWidth === 0) return;

  let totalSets;

  if (baseWidth > containerWidth) {
    // Case 1: already wider → just 2 sets
    totalSets = 2;
  } else {
    // Case 2: grow until wider, then double
    let minSetsForWidth = Math.floor(containerWidth / baseWidth) + 1;
    if (minSetsForWidth < 1) minSetsForWidth = 1;
    totalSets = minSetsForWidth * 2;
  }

  // Clone sets (1 set already exists)
  for (let setIndex = 1; setIndex < totalSets; setIndex++) {
    originalItems.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.setAttribute("role", "presentation");
      inner.appendChild(clone);
    });
  }

  scroller.setAttribute("data-animated", "true");
}

/* ==========================================================================
    header
========================================================================== */

function headerMenu() {
  return {
    isMenuOpen: false,
    previouslyFocusedEl: null,
    openMenu() {
      this.previouslyFocusedEl = document.activeElement;
      this.isMenuOpen = true;
      // disableScroll();
      this.$nextTick(() => {
        // focus the first focusable in the menu or the close button
        const menu = this.$refs.menu;
        if (!menu) return;
        const first = menu.querySelector(
          'a, button, input, [tabindex]:not([tabindex="-1"])'
        );
        (first || this.$refs.closeButton).focus();
      });
    },
    closeMenu() {
      this.isMenuOpen = false;
      // enableScroll();
      this.$nextTick(() => {
        try {
          if (
            this.previouslyFocusedEl &&
            typeof this.previouslyFocusedEl.focus === "function"
          ) {
            this.previouslyFocusedEl.focus();
          } else if (this.$refs.menuButton) {
            this.$refs.menuButton.focus();
          }
        } catch (e) {
          /**/
        }
      });
    },
  };
}


/* ==========================================================================
    header scrolling effect
========================================================================== */

const header = document.getElementById("header");
const ticker = document.getElementById("top-ticker");
let lastScroll = 0;
let tickerHeight = 0;
let headerHeight = 0;

const delta = 8;

function measure() {
  tickerHeight = ticker.offsetHeight;
  headerHeight = header.offsetHeight + tickerHeight;
}

window.addEventListener("scroll", () => {
  const y = window.scrollY;
    if (y > tickerHeight) {
    header.classList.add("ticker-scrolled");
  } else {
    header.classList.remove("ticker-scrolled");
  }

  // Ignore tiny micro scrolls (touch jitter)
  if (Math.abs(y - lastScroll) < delta) return;

  // Before passing header + ticker height → always show header
  if (y <= headerHeight) {
    header.classList.remove("header-scrolled");
    header.classList.remove("show");
    lastScroll = y;
    return;
  }

  header.classList.add("header-scrolled");

  // Scroll down → hide header
  if (y > lastScroll) {
    header.classList.remove("show");
  }

  // Scroll up → show header
  else {
    header.classList.add("show");
  }

  lastScroll = y;
});

window.addEventListener("resize", measure);
measure();


/*
    |--------------------------------------------------------------------------
    | unversal equal height set js
    |--------------------------------------------------------------------------
    */

function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}

function equalizeHeightsByGroup() {
  document.querySelectorAll('[data-equal-group]').forEach((group) => {
    // Collect all items inside the group
    const items = Array.from(group.children).filter((el) =>
      el.matches('div, article, section, li')
    );
    if (!items.length) return;

    // Collect all unique part types (like "profile", "heading")
    const parts = new Set();
    items.forEach((item) => {
      item.querySelectorAll('[data-equal-part]').forEach((el) => {
        parts.add(el.getAttribute('data-equal-part'));
      });
    });

    // Equalize each part type across all items
    parts.forEach((part) => {
      let maxHeight = 0;

      // Reset
      items.forEach((item) => {
        const el = item.querySelector(`[data-equal-part="${part}"]`);
        if (el) el.style.removeProperty('--height');
      });

      // Measure
      items.forEach((item) => {
        const el = item.querySelector(`[data-equal-part="${part}"]`);
        if (el) maxHeight = Math.max(maxHeight, el.offsetHeight);
      });

      // Apply
      items.forEach((item) => {
        const el = item.querySelector(`[data-equal-part="${part}"]`);
        if (el) el.style.setProperty('--height', `${maxHeight}px`);
      });
    });
  });
}

window.addEventListener('load', equalizeHeightsByGroup);
window.addEventListener('resize', debounce(equalizeHeightsByGroup, 200));




/*
    |--------------------------------------------------------------------------
    | get top-header height js
    |--------------------------------------------------------------------------
    */

function updateHeaderHeight() {
  const header = document.querySelector(".get-top-header-height");
  if (header) {
    const height = header.offsetHeight; // element’s rendered height
    document.documentElement.style.setProperty(
      "--header-height",
      height + "px"
    );
  }
}
// Run once on load
updateHeaderHeight();
window.addEventListener("resize", updateHeaderHeight);



//  --menu-list-height = mobile-menu-height--js - close-button-wrapper-height--js - search-wrapper-height--js - shop-now-wrapper-height--js - socials-wrapper-height--js - 58px(nav-margin-bottom)


function calculateMobileMenuHeight() {
  const menu = document.querySelector('.mobile-menu-height--js');
  if (!menu) return;

  const getHeight = (selector) =>
    menu.querySelector(selector)?.offsetHeight || 0;

  const menuHeight     = menu.offsetHeight;
  const closeBtnHeight = getHeight('.close-button-wrapper-height--js');
  const searchHeight   = getHeight('.search-wrapper-height--js');
  const shopNowHeight  = getHeight('.shop-now-wrapper-height--js');
  const socialsHeight  = getHeight('.socials-wrapper-height--js');

  // const NAV_MARGIN = 55;
  const NAV_MARGIN = window.matchMedia('(max-width: 510px)').matches ? 15 : 55;

  const menuListHeight =
    menuHeight -
    closeBtnHeight -
    searchHeight -
    shopNowHeight -
    socialsHeight -
    NAV_MARGIN;

  menu.style.setProperty(
    '--menu-list-height',
    `${Math.max(menuListHeight, 0)}px`
  );

   window.initFBWScrollbar();
}


  /*
    |--------------------------------------------------------------------------
    | used in product details page
    | Check if sticky button is in viewport and toggle 'not-in-view' class
    |--------------------------------------------------------------------------
    | This function monitors the button's position on every scroll event.
    | When the button scrolls out of view, it adds the 'not-in-view' class.
    | using tailwind css for styling based on 'not-in-view' class
    | When the button comes back into view, it removes the class.
    | Typically used to show/hide a fixed sticky button based on original position.
    |--------------------------------------------------------------------------
    */
// Get the button element
const stickyButton = document.querySelector('.addToCart-sticky-js');

if (stickyButton) {
  // Function to check if element is in viewport
  function checkIfInView() {
    const rect = stickyButton.getBoundingClientRect();
    const isInView = (
      rect.bottom >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
    
    if (isInView) {
      stickyButton.classList.remove('not-in-view');
    } else {
      stickyButton.classList.add('not-in-view');
    }
  }
  
  // Check on page load
  checkIfInView();
  
  // Check on scroll
  window.addEventListener('scroll', checkIfInView);
  
  // Optional: Check on resize
  window.addEventListener('resize', checkIfInView);
}



/*
    |--------------------------------------------------------------------------
    | Mobile Instagram Navigation Click Handler
    |--------------------------------------------------------------------------
    | This script manages the Instagram feed navigation behavior on mobile devices 
    | (below 768px width) by hiding the static box and enabling proper slide navigation.
    | 
    | Functionality:
    | - Detects if viewport width is below 768px
    | - Listens for clicks on .instafeed-new-arrow-next and .instafeed-new-arrow-prev
    | - On first click (mobile only):
    |   * Adds 'mobile-insta-nav-clicked' class to hide .instafeed-static-box-js
    |   * Waits for transition to complete
    |   * Resets wrapper position to 0px to account for new container width
    |   * Does NOT navigate/slide on this first click
    | - On subsequent clicks:
    |   * Calculates and applies proper slide transforms
    |   * Moves one item width (+ gap) per click
    |   * Prevents sliding beyond boundaries
    |   * Adds 'disable' class to prev/next arrows when at start/end of carousel
    | - Resets when viewport exceeds 768px width
    | 
    | Safety: Exits gracefully if required elements are not present in the DOM
    | Uses MutationObserver to wait for dynamically loaded arrow elements
    |--------------------------------------------------------------------------
    */

document.addEventListener('DOMContentLoaded', function() {
  // Check if screen width is below 768px (mobile breakpoint)
  function isMobile() {
    return window.innerWidth < 768;
  }

  /**
   * Disable touch-swipe dragging on the Instagram feed carousel on mobile,
   * while still allowing taps (e.g. opening a post) and arrow-button navigation.
   * Only blocks the gesture once real horizontal movement is detected, so a
   * plain tap never gets its touchstart/click sequence interrupted.
   */
  (function disableInstafeedTouchSwipe() {
    let tracking = false;
    let startX = 0;
    let startY = 0;

    document.addEventListener('touchstart', function(e) {
      tracking = false;
      if (!isMobile()) return;

      const insideCarousel = e.target.closest(
        '.instafeed-new-layout-container, .instafeed-new-layout-wrapper, .instafeed-new-layout-item'
      );
      const onArrow = e.target.closest(
        '.instafeed-new-arrow-next, .instafeed-new-arrow-prev'
      );

      if (!insideCarousel || onArrow) return;

      tracking = true;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { capture: true, passive: true });

    document.addEventListener('touchmove', function(e) {
      if (!tracking || !isMobile()) return;

      const dx = Math.abs(e.touches[0].clientX - startX);
      const dy = Math.abs(e.touches[0].clientY - startY);

      // Only swallow the gesture once it's clearly a horizontal drag,
      // so vertical page scrolling still works normally.
      if (dx > dy && dx > 5) {
        e.stopPropagation();
        if (e.cancelable) e.preventDefault();
      }
    }, { capture: true, passive: false });
  })();

  // Get static box element
  const staticBox = document.querySelector('.instafeed-static-box-js');


  // Exit if static box doesn't exist
  if (!staticBox) {
    return;
  }

  // Flag to track if navigation has been activated (first click occurred)
  let hasClicked = false;

  /**
   * Update disabled state of navigation arrows based on current position
   */
  function updateArrowStates() {
    const wrapper = document.querySelector('.instafeed-new-layout-wrapper');
    const container = document.querySelector('.instafeed-new-layout-container');
    const item = document.querySelector('.instafeed-new-layout-item');
    const allItems = document.querySelectorAll('.instafeed-new-layout-item');
    const nextArrow = document.querySelector('.instafeed-new-arrow-next');
    const prevArrow = document.querySelector('.instafeed-new-arrow-prev');
    
    if (!wrapper || !item || !container || allItems.length === 0 || !nextArrow || !prevArrow) return;
    
    const itemWidth = item.offsetWidth + 10; // Item width + 10px gap
    const containerWidth = container.offsetWidth; // Visible container width
    const totalItems = allItems.length;
    const totalWidth = totalItems * itemWidth; // Total width of all slides
    const maxOffset = totalWidth - containerWidth; // Maximum we can scroll
    
    // Get current offset from transform
    const currentTransform = wrapper.style.transform;
    const currentOffset = Math.abs(parseFloat(currentTransform.match(/translateX\(([-\d.]+)px\)/)?.[1] || 0));
    
    // Add/remove 'disable' class for prev arrow if at the start
    if (currentOffset === 0) {
      prevArrow.classList.add('disable');
    } else {
      prevArrow.classList.remove('disable');
    }
    
    // Add/remove 'disable' class for next arrow if at the end
    if (currentOffset >= maxOffset) {
      nextArrow.classList.add('disable');
    } else {
      nextArrow.classList.remove('disable');
    }
    
  }

  /**
   * Calculate and apply slide transform based on direction
   * @param {string} direction - 'next' or 'prev'
   */
  function correctSlideTransform(direction) {
    const wrapper = document.querySelector('.instafeed-new-layout-wrapper');
    const container = document.querySelector('.instafeed-new-layout-container');
    const item = document.querySelector('.instafeed-new-layout-item');
    const allItems = document.querySelectorAll('.instafeed-new-layout-item');
    
    if (!wrapper || !item || !container || allItems.length === 0) return;
    
    const itemWidth = item.offsetWidth + 10; // Item width + 10px gap
    const containerWidth = container.offsetWidth; // Visible container width
    const totalItems = allItems.length;
    const totalWidth = totalItems * itemWidth; // Total width of all slides
    const maxOffset = totalWidth - containerWidth; // Maximum we can scroll
    
    // Get current offset from transform
    const currentTransform = wrapper.style.transform;
    const currentOffset = Math.abs(parseFloat(currentTransform.match(/translateX\(([-\d.]+)px\)/)?.[1] || 0));
    
    let correctOffset;
    
    if (direction === 'next') {
      // Move forward by one item width
      correctOffset = -(currentOffset + itemWidth);
      
      // Cap at maxOffset to prevent over-scrolling
      if (Math.abs(correctOffset) > maxOffset) {
        correctOffset = -maxOffset;
      }
    } else if (direction === 'prev') {
      // Move backward by one item width
      correctOffset = -(currentOffset - itemWidth);
      
      // Don't go past the start (0)
      if (correctOffset > 0) {
        correctOffset = 0;
      }
    }
    
    // Apply the calculated transform
    wrapper.style.transform = `translateX(${correctOffset}px)`;
    
    
    // Update arrow states after sliding
    updateArrowStates();
  }

  /**
   * Handle arrow click events
   * First click on mobile: Hide static box and prepare for navigation
   * Subsequent clicks: Navigate through slides
   */
  function handleArrowClick(e) {
    
    // First click on mobile - activate navigation (allow even if disabled)
    if (isMobile() && !hasClicked) {
      
      // Prevent Instafeed's default behavior
      // Don't allow prev arrow on first click (should stay disabled at start)
    if (e.currentTarget.classList.contains('instafeed-new-arrow-prev')) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
      e.preventDefault();
      e.stopPropagation();
      
      // Hide static box to give full width to carousel
      staticBox.classList.add('mobile-insta-nav-clicked');
      hasClicked = true;
      
      // Wait for transition to complete, then reset position
      setTimeout(function() {
        // Reset wrapper position to 0 since container width has changed
        const wrapper = document.querySelector('.instafeed-new-layout-wrapper');
        if (wrapper) {
          wrapper.style.transform = 'translateX(0px)';
          // Update arrow states after reset
          updateArrowStates();
        }
      }, 350); // Wait for transition (duration-300 = 300ms + buffer)
      
      return; // Exit early - no sliding on first click
    }
    
    // Don't proceed if button has 'disable' class (after first click)
    if (e.currentTarget.classList.contains('disable')) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    // Subsequent clicks - perform navigation
    // Prevent Instafeed's default behavior
    e.preventDefault();
    e.stopPropagation();
    
    // Determine direction and perform slide
    const isNext = e.currentTarget.classList.contains('instafeed-new-arrow-next');
    correctSlideTransform(isNext ? 'next' : 'prev');
  }

  /**
   * Attach click listeners to arrow elements
   * @returns {boolean} True if arrows found and listeners attached
   */
  function attachArrowListeners() {
    const nextArrow = document.querySelector('.instafeed-new-arrow-next');
    const prevArrow = document.querySelector('.instafeed-new-arrow-prev');


    if (nextArrow && prevArrow) {
      // Use capture phase (true) to intercept before Instafeed's handlers
      nextArrow.addEventListener('click', handleArrowClick, true);
      prevArrow.addEventListener('click', handleArrowClick, true);
      
      // Set initial arrow states
      updateArrowStates();
      
      return true;
    }
    return false;
  }

  // Try to attach listeners immediately
  if (!attachArrowListeners()) {
    
    // Use MutationObserver to wait for arrows to load dynamically
    const observer = new MutationObserver(function(mutations) {
      if (attachArrowListeners()) {
        observer.disconnect();
      }
    });

    // Observe the document body for added nodes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Set a timeout to stop observing after 10 seconds
    setTimeout(() => {
      observer.disconnect();
    }, 10000);
  }

  // Reset navigation state when resizing above mobile breakpoint
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      if (!isMobile()) {
        hasClicked = false;
        staticBox.classList.remove('mobile-insta-nav-clicked');
        
        // Reset transform to starting position
        const wrapper = document.querySelector('.instafeed-new-layout-wrapper');
        if (wrapper) {
          wrapper.style.transform = 'translateX(0px)';
        }
        
        // Update arrow states after reset
        updateArrowStates();
      }
    }, 250); // Debounce resize events
  });
});





/* ==========================================================================
    custom scrollbar
========================================================================== */

/**
 * FBW Custom Scrollbar — Performance Optimized
 * ─────────────────────────────────────────────────────────
 * KEY OPTIMIZATION:
 * - getBoundingClientRect() called ONCE on init, not on scroll
 * - Scroll handler does pure math only (no DOM reads)
 * - requestAnimationFrame batches DOM writes
 * - MutationObserver handles menu open/close
 */

(function () {

  window.initFBWScrollbar = function () {
    document.querySelectorAll('.custom-fbw-scroll').forEach(function (el) {

      // Avoid double-init
      if (el._fbwScrollbar) {
        el._fbwScrollbar.refresh();
        return;
      }

      // ── Create track + thumb on body ─────────────────────
      const track = document.createElement('div');
      track.className = 'fbw-custom-track';

      const thumb = document.createElement('div');
      thumb.className = 'fbw-custom-thumb';

      track.appendChild(thumb);
      document.body.appendChild(track);

      // ── Prevent Alpine @click.outside from firing on track ──
      track.addEventListener('mousedown', function(e) {
        e.stopPropagation();
      });
      track.addEventListener('click', function(e) {
        e.stopPropagation();
      });

      // ── Cache measurements — only recalculate on resize/open
      let cachedRect     = null;
      let cachedTrackH   = 0;
      let cachedThumbH   = 0;
      let cachedScrollable = 0;
      let cachedThumbMovable = 0;
      let rafPending     = false;

      function cacheMeasurements() {
        cachedRect       = el.getBoundingClientRect(); // only called here
        cachedTrackH     = cachedRect.height - 8;

        const contentH   = el.scrollHeight;
        const visibleH   = el.clientHeight;
        const ratio      = visibleH / contentH;

        cachedScrollable   = contentH - visibleH;
        cachedThumbH       = Math.max(ratio * cachedTrackH, 30);
        cachedThumbMovable = cachedTrackH - cachedThumbH;

        // Position track once using cached rect
        track.style.top    = (cachedRect.top + 4) + 'px';
        track.style.height = cachedTrackH + 'px';
        track.style.right  = '28px';

        // Set thumb height once
        thumb.style.height = cachedThumbH + 'px';

        // Show/hide based on overflow
        const overflows = cachedScrollable > 1;
        track.classList.toggle('is-visible', overflows && cachedRect.height > 0);
      }

      // ── Scroll handler — pure math, no DOM reads ──────────
      function onScroll() {
        if (rafPending) return;
        rafPending = true;

        requestAnimationFrame(function () {
          rafPending = false;

          if (cachedScrollable <= 0) return;

          const thumbTop = (el.scrollTop / cachedScrollable) * cachedThumbMovable;
          thumb.style.top = thumbTop + 'px'; // only 1 DOM write per frame
        });
      }

      // ── Hide track ────────────────────────────────────────
      function hide() {
        track.classList.remove('is-visible');
        cachedRect = null;
      }

      // ── Recache on resize ─────────────────────────────────
      let resizeRaf = false;
      window.addEventListener('resize', function () {
        if (resizeRaf) return;
        resizeRaf = true;
        requestAnimationFrame(function () {
          resizeRaf = false;
          cacheMeasurements();
        });
      }, { passive: true });

      // ── Reposition track on body scroll (for sticky ticker) ──
      // Only update track.top — don't recalculate everything
      let bodyScrollRaf = false;
      window.addEventListener('scroll', function () {
        if (!track.classList.contains('is-visible')) return;
        if (bodyScrollRaf) return;
        bodyScrollRaf = true;
        requestAnimationFrame(function () {
          bodyScrollRaf = false;
          const rect = el.getBoundingClientRect();
          track.style.top = (rect.top + 4) + 'px';
        });
      }, { passive: true });

      // ── Scroll listener ───────────────────────────────────
      el.addEventListener('scroll', onScroll, { passive: true });

      // ── Watch menu open/close via MutationObserver ────────
      const menu = document.querySelector('#mobile-menu');
      if (menu) {
        const observer = new MutationObserver(function () {
          // NOTE: Do NOT use !menu.offsetParent —
          // position:fixed elements always return null on iOS
          // even when fully visible. Only trust aria-hidden.
          const isHidden =
            menu.style.display === 'none' ||
            menu.getAttribute('aria-hidden') === 'true';

          if (isHidden) {
            hide();
          } else {
            // Hide track completely during transition
            track.classList.remove('is-visible');

            // Alpine fires multiple transitionend events (one per property)
            // Debounce so we only measure after the LAST one fires
            let transitionTimer = null;
            function onEnd() {
              clearTimeout(transitionTimer);
              transitionTimer = setTimeout(function () {
                menu.removeEventListener('transitionend', onEnd);
                cacheMeasurements();
              }, 50);
            }
            menu.addEventListener('transitionend', onEnd);

            // iOS Safari fallback — transitionend sometimes never fires
            // so also run after a safe timeout as backup
            setTimeout(function () {
              if (!track.classList.contains('is-visible')) {
                cacheMeasurements();
              }
            }, 500);
          }
        });

        observer.observe(menu, {
          attributes: true,
          attributeFilter: ['style', 'aria-hidden']
        });
      }

      // ── Mouse drag: thumb → scroll ───────────────────────
      let isDragging         = false;
      let dragStartY         = 0;
      let dragStartScrollTop = 0;

      thumb.addEventListener('mousedown', function (e) {
        isDragging         = true;
        dragStartY         = e.clientY;
        dragStartScrollTop = el.scrollTop;
        document.body.style.userSelect = 'none';
        
        // Mark menu as "ignore clicks outside" while dragging
        if (menu) {
          menu.setAttribute('data-scrollbar-dragging', 'true');
        }
        
        e.preventDefault();
        e.stopImmediatePropagation();
      });

      document.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        e.stopPropagation();
        const delta       = e.clientY - dragStartY;
        const scrollDelta = cachedThumbMovable > 0
          ? (delta / cachedThumbMovable) * cachedScrollable
          : 0;
        el.scrollTop = Math.max(0, Math.min(cachedScrollable, dragStartScrollTop + scrollDelta));
      });

      document.addEventListener('mouseup', function (e) {
        if (isDragging) {
          isDragging = false;
          document.body.style.userSelect = '';
          
          // Re-enable click.outside after a small delay
          if (menu) {
            setTimeout(function() {
              menu.removeAttribute('data-scrollbar-dragging');
            }, 100);
          }
          
          e.stopPropagation();
        }
      });

      // ── Touch drag: thumb → scroll (iOS) ─────────────────
      let touchStartY         = 0;
      let touchStartScrollTop = 0;
      let isTouchDragging     = false;

      thumb.addEventListener('touchstart', function (e) {
        isTouchDragging     = true;
        touchStartY         = e.touches[0].clientY;
        touchStartScrollTop = el.scrollTop;
        
        // Mark menu to prevent close during touch drag
        if (menu) {
          menu.setAttribute('data-scrollbar-dragging', 'true');
        }
        
        e.preventDefault();
        e.stopPropagation();
      }, { passive: false });

      thumb.addEventListener('touchmove', function (e) {
        if (!isTouchDragging) return;
        const delta       = e.touches[0].clientY - touchStartY;
        const scrollDelta = cachedThumbMovable > 0
          ? (delta / cachedThumbMovable) * cachedScrollable
          : 0;
        el.scrollTop = Math.max(0, Math.min(cachedScrollable, touchStartScrollTop + scrollDelta));
        e.preventDefault();
      }, { passive: false });

      thumb.addEventListener('touchend', function (e) {
        if (isTouchDragging) {
          isTouchDragging = false;
          
          // Re-enable click.outside after touch drag
          if (menu) {
            setTimeout(function() {
              menu.removeAttribute('data-scrollbar-dragging');
            }, 100);
          }
        }
      }, { passive: true });

        // ── Click track to jump ──────────────────────────────
      track.addEventListener('click', function (e) {
        if (e.target === thumb) return;
        const rect         = track.getBoundingClientRect();
        const clickY       = e.clientY - rect.top;
        const ratio        = cachedThumbMovable > 0
          ? (clickY - cachedThumbH / 2) / cachedThumbMovable
          : 0;
        const targetScroll = Math.max(0, Math.min(cachedScrollable, ratio * cachedScrollable));
        el.scrollTo({
          top: targetScroll,
          behavior: 'smooth'
        });
      });

      // ── Store ref ────────────────────────────────────────
      el._fbwScrollbar = { refresh: cacheMeasurements, hide };

      // ── Don't measure on init — menu is closed ───────────
      // cacheMeasurements() will be called by MutationObserver
      // when the menu actually opens for the first time
    });
  };

})();



/**
 * Chatbot Custom Scrollbar
 * ─────────────────────────────────────────────────────────
 * Separate implementation for chatbot with white thumb
 */
(function () {

  window.initChatbotScrollbar = function () {
    document.querySelectorAll('.chatbot-custom-scroll').forEach(function (el) {

      // Avoid double-init
      if (el._chatbotScrollbar) {
        el._chatbotScrollbar.refresh();
        return;
      }

      // ── Create track + thumb on body ─────────────────────
      const track = document.createElement('div');
      track.className = 'chatbot-scrollbar-track';

      const thumb = document.createElement('div');
      thumb.className = 'chatbot-scrollbar-thumb';

      track.appendChild(thumb);
      document.body.appendChild(track);

      // ── Cache measurements ───────────────────────────────
      let cachedRect       = null;
      let cachedTrackH     = 0;
      let cachedThumbH     = 0;
      let cachedScrollable = 0;
      let cachedThumbMovable = 0;
      let rafPending       = false;

      let isDragging       = false;
      let isTouchDragging  = false;

      function cacheMeasurements() {
        cachedRect       = el.getBoundingClientRect();
        cachedTrackH     = cachedRect.height - 8;

        const contentH   = el.scrollHeight;
        const visibleH   = el.clientHeight;
        const ratio      = visibleH / contentH;

        cachedScrollable   = contentH - visibleH;
        cachedThumbH       = Math.max(ratio * cachedTrackH, 30);
        cachedThumbMovable = cachedTrackH - cachedThumbH;

        // Position track relative to chatbot container
        track.style.top    = (cachedRect.top + 4) + 'px';
        track.style.height = cachedTrackH + 'px';

        // Position 8px from the chatbot container's right edge
        // track.style.right  = (window.innerWidth - cachedRect.right) + 'px';

        // Set thumb height
        thumb.style.height = cachedThumbH + 'px';

        // Show/hide based on overflow
        const overflows = cachedScrollable > 1;
        track.classList.toggle('is-visible', overflows && cachedRect.height > 0);
      }

      // ── Scroll handler ────────────────────────────────────
      function onScroll() {
        if (isDragging || isTouchDragging) return;
        if (rafPending) return;
        rafPending = true;

        requestAnimationFrame(function () {
          rafPending = false;

          if (cachedScrollable <= 0) return;

          const thumbTop = (el.scrollTop / cachedScrollable) * cachedThumbMovable;
          thumb.style.top = thumbTop + 'px';
        });
      }

      // ── Hide track ────────────────────────────────────────
      function hide() {
        track.classList.remove('is-visible');
        cachedRect = null;
      }

      // ── Recache on resize ─────────────────────────────────
      let resizeRaf = false;
      window.addEventListener('resize', function () {
        if (resizeRaf) return;
        resizeRaf = true;
        requestAnimationFrame(function () {
          resizeRaf = false;
          if (track.classList.contains('is-visible')) {
            cacheMeasurements();
          }
        });
      }, { passive: true });

      // ── Scroll listener ───────────────────────────────────
      el.addEventListener('scroll', onScroll, { passive: true });

      // ── Mouse drag: thumb → scroll ───────────────────────
      let dragStartY         = 0;
      let dragStartScrollTop = 0;

      thumb.addEventListener('mousedown', function (e) {
        isDragging         = true;
        dragStartY         = e.clientY;
        dragStartScrollTop = el.scrollTop;
        document.body.style.userSelect = 'none';

        cachedRect         = el.getBoundingClientRect();
        cachedTrackH       = cachedRect.height - 8;
        const contentH     = el.scrollHeight;
        const visibleH     = el.clientHeight;
        const ratio        = visibleH / contentH;
        cachedScrollable   = contentH - visibleH;
        cachedThumbH       = Math.max(ratio * cachedTrackH, 30);
        cachedThumbMovable = cachedTrackH - cachedThumbH;

        e.preventDefault();
        e.stopImmediatePropagation();
      });

      document.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        const delta       = e.clientY - dragStartY;
        const scrollDelta = cachedThumbMovable > 0
          ? (delta / cachedThumbMovable) * cachedScrollable
          : 0;
        el.scrollTop = Math.max(0, Math.min(cachedScrollable, dragStartScrollTop + scrollDelta));
        thumb.style.top = ((el.scrollTop / cachedScrollable) * cachedThumbMovable) + 'px';
      });

      document.addEventListener('mouseup', function (e) {
        if (isDragging) {
          isDragging = false;
          document.body.style.userSelect = '';
        }
      });

      // ── Touch drag: thumb → scroll ───────────────────────
      let touchStartY         = 0;
      let touchStartScrollTop = 0;

      thumb.addEventListener('touchstart', function (e) {
        isTouchDragging     = true;
        touchStartY         = e.touches[0].clientY;
        touchStartScrollTop = el.scrollTop;

        cachedRect         = el.getBoundingClientRect();
        cachedTrackH       = cachedRect.height - 8;
        const contentH     = el.scrollHeight;
        const visibleH     = el.clientHeight;
        const ratio        = visibleH / contentH;
        cachedScrollable   = contentH - visibleH;
        cachedThumbH       = Math.max(ratio * cachedTrackH, 30);
        cachedThumbMovable = cachedTrackH - cachedThumbH;

        e.preventDefault();
        e.stopPropagation();
      }, { passive: false });

      thumb.addEventListener('touchmove', function (e) {
        if (!isTouchDragging) return;
        const delta       = e.touches[0].clientY - touchStartY;
        const scrollDelta = cachedThumbMovable > 0
          ? (delta / cachedThumbMovable) * cachedScrollable
          : 0;
        el.scrollTop = Math.max(0, Math.min(cachedScrollable, touchStartScrollTop + scrollDelta));
        thumb.style.top = ((el.scrollTop / cachedScrollable) * cachedThumbMovable) + 'px';
        e.preventDefault();
      }, { passive: false });

      thumb.addEventListener('touchend', function () {
        isTouchDragging = false;
      });

      // ── Click track to jump ──────────────────────────────
      track.addEventListener('click', function (e) {
        if (e.target === thumb) return;
        const rect         = track.getBoundingClientRect();
        const clickY       = e.clientY - rect.top;
        const ratio        = cachedThumbMovable > 0
          ? (clickY - cachedThumbH / 2) / cachedThumbMovable
          : 0;
        const targetScroll = Math.max(0, Math.min(cachedScrollable, ratio * cachedScrollable));
        el.scrollTo({
          top: targetScroll,
          behavior: 'smooth'
        });
      });

      // ── Store ref ────────────────────────────────────────
      el._chatbotScrollbar = { refresh: cacheMeasurements, hide };

      // ── Initial measurement ──────────────────────────────
      cacheMeasurements();
    });
  };

})();




